import L from 'leaflet';

export default () => ({
  isMapVisible: false,
  markers: [],
  bounds: null,
  initialLoad: true,
  isLoading: true,
  isZoomed: false,
  w: 8000,
  h: 2753,
  magicConstantForMarkerPosition: 2.85,
  config: {
    minZoom: 1,
    maxZoom: 3.5,
    center: [0, 0],
    zoom: 1,
    crs: L.CRS.Simple,
    maxBoundsViscosity: 1,
    inertiaDeceleration: 500,
  },
  map: null,
  isMobile() {
    return window.innerWidth < 768;
  },
  clearMap() {
    this.zoomToMarker(true);
  },
  zoomToMarker(clear = false) {
    if (!this.$store.router.id || clear === true) {
      this.isZoomed = false;
      this.$dispatch('zoom-out');

      markersData.forEach((m) => {
        m.leaflet.setIcon(this.getIcon(m));
      });

      if (this.initialLoad) {
        setTimeout(() => {
          if (!this.isMobile()) {
            this.map.setView(
              this.map.unproject([1500, 1100]),
              this.config.minZoom,
              { animate: false }
            );
          } else {
            this.map.setView(
              this.map.unproject([1650, 1100]),
              this.config.minZoom,
              { animate: false }
            );
          }
        }, 300);
      } else {
        // this.map.setViewOffset(
        //   this.map.getCenter(),
        //   [window.innerWidth / 2, 0],
        //   this.config.minZoom
        // );
        this.map.once('zoomend moveend', () => {});
        setTimeout(() => {
          this.map.invalidateSize(false);
          setTimeout(() => {
            this.map.setView(this.map.getCenter(), this.config.minZoom);
          }, 250);
        }, 1);
      }
    } else {
      this.isZoomed = true;
      this.$dispatch('zoom-in');
      const marker = this.getMarker();

      markersData.forEach((m) => {
        m.leaflet.setIcon(this.getIcon(m));
      });

      marker.leaflet.setIcon(this.getActiveIcon(marker));

      // marker.leaflet.setIcon(plannedIcon);
      setTimeout(() => {
        const latlng = marker.leaflet.getLatLng();
        this.map.invalidateSize(true);
        this.map.setView(latlng, 3, { animate: true });
      }, 300);
    }

    this.initialLoad = false;
  },
  showHideMarkers(e) {
    const year = this.$store.global.showYear;

    markersData.forEach((marker, i) => {
      if (
        marker.show_at_year <= year &&
        this.$store.global.filters[marker.category]
      ) {
        if (!marker.isVisible) {
          marker.leaflet.addTo(this.map);

          markersData[i].isVisible = true;
        }
      } else {
        this.map.removeLayer(marker.leaflet);
        markersData[i].isVisible = false;
      }
    });

    let investmentAmount = 0;
    let numVisible = 0;

    markersData.forEach((marker) => {
      if (marker.isVisible) {
        if (marker.price && !isNaN(parseInt(marker.price))) {
          investmentAmount += parseInt(marker.price);
        }

        numVisible += 1;
      }
    });

    this.$store.global.setInvestmentAmount(investmentAmount);
    this.$store.global.numVisibleMarkers = numVisible;
  },
  getMarker() {
    const { id } = this.$store.router;
    return markersData.find((marker) => marker.slug === id);
  },
  showMap() {
    this.isMapVisible = true;
  },
  getIcon(marker) {
    return new L.divIcon({
      className: `Map-marker Map-marker--${marker.category}`,
      html: `<div class='Map-markerTooltip' style='max-width: ${this.getTooltipWidth(
        marker.name
      )}em; text-align: ${this.getTooltipAlignment(marker.name)}'>${
        marker.name
      }</div><div class='Map-markerNumber'>${marker.number}</div>`,
      iconSize: [35, 50],
      iconAnchor: [16, 50],
    });
  },
  getTooltipWidth(name) {
    let divisor = 1;
    const l = name.length;

    if (l > 30) {
      divisor = 2;
    }

    return (Math.ceil(name.length * 0.6) + 2) / divisor;
  },
  getTooltipAlignment(name) {
    const l = name.length;
    if (l > 30) {
      return 'left';
    }

    return 'center';
  },
  getActiveIcon(marker) {
    return L.divIcon({
      className: 'Map-marker Map-marker--active',
      html: `<div class='Map-markerNumber'>${marker.number}</div>`,
      iconSize: [35, 50],
      iconAnchor: [16, 50],
    });
  },
  init() {
    setTimeout(() => {
      L.Map.prototype.setViewOffset = function (latlng, offset, targetZoom) {
        const targetPoint = this.project(latlng, targetZoom).subtract(offset);
        const targetLatLng = this.unproject(targetPoint, targetZoom);
        return this.setView(targetLatLng, targetZoom, { animate: true });
      };

      this.map = L.map('map', this.config);

      // dimensions of the image
      const { w } = this;
      const { h } = this;
      const url = '/assets/bg_photo.png';

      // calculate the edges of the image, in coordinate space
      let southWest = this.map.unproject([0, h], this.map.getMaxZoom() - 1);
      let northEast = this.map.unproject([w, 0], this.map.getMaxZoom() - 1);
      let bounds = new L.LatLngBounds(southWest, northEast);

      this.bounds = bounds;

      // add the image overlay,
      // so that it covers the entire this.map
      L.imageOverlay(url, bounds)
        .addTo(this.map)
        .on('load', () => {
          setTimeout(() => {
            this.isLoading = false;
            this.$dispatch('map-loaded');
            if (localStorage.getItem('show-map') === '1') {
              this.$dispatch('show-map');
            }
          }, 100);
          this.showHideMarkers({ detail: 9999 });
        });

      // tell leaflet that the this.map is exactly as big as the image
      southWest = this.map.unproject([0, h], this.map.getMaxZoom() - 1);
      northEast = this.map.unproject([w, 0], this.map.getMaxZoom() - 1);
      bounds = new L.LatLngBounds(southWest, northEast);
      this.map.setMaxBounds(bounds);

      this.config.minZoom = this.map.getBoundsZoom(this.bounds, true);
      this.map.setMinZoom(this.config.minZoom);

      this.map.on('click', (e) => {
        const coords = this.map.project(e.latlng);
        console.log({
          x: coords.x * this.magicConstantForMarkerPosition,
          y: coords.y * this.magicConstantForMarkerPosition,
        });
      });

      // bind events to markers
      this.markers = markersData = markersData.map((marker) => {
        const newMarker = {
          ...marker,
          isVisible: false,
          leaflet: L.marker(
            this.map.unproject([
              marker.x / this.magicConstantForMarkerPosition,
              marker.y / this.magicConstantForMarkerPosition,
            ]),
            {
              icon: this.getIcon(marker),
            }
          ),
        };

        newMarker.leaflet.on('click', (e) => {
          this.$dispatch('navigate', newMarker.slug);
        });

        return newMarker;
      });
    });
  },
});
